import { ApiUrl, ApiUrlAdmin,ApiUrlDevelop } from "../common/Config";
import { postAdmin,post,get,getAdmin,postFormData } from "../common/Helper";

export const GetAllCoaches = async (token,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/getbyadminpanel`
    return await get(url,token,isAdmin)
}
export const GetCoachDetail = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/getbyid?coachId=${data}`
    return await get(url,token,isAdmin)
}
export const AddCoach = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/addCoach`
    return await post(url, data, token);
}
export const UpdateCoach = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/updateCoach`
    return await post(url, data, token);
}
export const GetBadges = async (token,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/getBadges`
    return await get(url,token,isAdmin)
}
export const AddBadge = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/addBadge`
    return await post(url, data, token);
}

export const GetCoachStudents = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/getcoachstudents?coachUserId=${data}`
    return await get(url,token,isAdmin)
}
export const GetCoachMeetings = async (token,data,isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/coachmeetings?coachUserId=${data.UserId}&examCategoryId=${data.ExamCategoryId}`
    return await get(url,token,isAdmin)
}

// All coaches' meetings (for the "Tüm Toplantı Kayıtları" page).
//
// The dataset is large (1000+, growing daily), so this is SERVER-SIDE paginated
// and filtered: the client POSTs the page + active filters and gets back one
// page plus totals. It never fetches the whole list.
//
// POST coaching/allcoachmeetings
// body: { pageNumber, pageSize, coachUserId, studentUserId, minDate, maxDate }
// resp: { pageNumber, pageSize, pageCount, totalItemCount, items: [ { meetingId,
//         coachUserId, coachName, coachSurname, studentUserId, studentName,
//         studentSurname, title, date, recordings: [{ id, recordUrl, status }] } ] }
export const GetAllCoachMeetings = async (token, params, isAdmin) =>{
    let url = ApiUrlAdmin + `coaching/allcoachmeeting`
    return await post(url, params, token);
}
